import { gql, useApolloClient } from '@apollo/client';
import { useCallback } from 'react';

import { WebShopRequest } from '@work4all/models/lib/Classes/WebShopRequest.entity';

const GET_WEBSHOP_REQUEST_COMPLETED = gql`
  query getWebshopRequestsCompleted(
    $shadowBzObjectId: Guid
    $bzObjMemberCode: Int
    $bzObjType: BzObjType
  ) {
    getWebshopRequestsCompleted(
      shadowBzObjectId: $shadowBzObjectId
      bzObjMemberCode: $bzObjMemberCode
      bzObjType: $bzObjType
    ) {
      shadowBzObjectId: shadowBzObjectId
      response: response
      bzObjMemberCode: bzObjMemberCode
      bzObjType: bzObjType
      id: id
      insertTime: insertTime
      updateTime: updateTime
      userCode: userCode
      __typename
    }
  }
`;

const DELETE_OCI_WEBSHOP_REQUEST = gql`
  mutation deleteWebshopRequest($shadowBzObjectId: Guid!) {
    deleteWebshopRequest(shadowBzObjectId: $shadowBzObjectId)
  }
`;

export const useWebshopApi = () => {
  const client = useApolloClient();

  const getWebshopRequestsCompleted = useCallback(
    async (shadowBzObjectId: string) => {
      return await client.query<{
        getWebshopRequestsCompleted: WebShopRequest;
      }>({
        fetchPolicy: 'no-cache',
        query: GET_WEBSHOP_REQUEST_COMPLETED,
        variables: {
          shadowBzObjectId,
        },
      });
    },
    [client]
  );

  const deleteWebshopRequest = useCallback(
    async (shadowBzObjectId: string) => {
      return await client.query({
        fetchPolicy: 'no-cache',
        query: DELETE_OCI_WEBSHOP_REQUEST,
        variables: {
          shadowBzObjectId,
        },
      });
    },
    [client]
  );

  return { getWebshopRequestsCompleted, deleteWebshopRequest };
};
